export default __webpack_public_path__ + "static/media/justice.71077c7b.png";